import { BRAND_BASE, BRAND_INSEL } from '../../../config/brand'

const BASE_WIDTHS = Object.freeze({
  name: 59.5 / 3,
  alarmId: 59.5 / 3,
  alarmPlan: 59.5 / 3,
  systemId: 8.5,
  alarmStatus: 8.5,
  mode: 8.5,
  orgName: 15,
})

const INSEL_WIDTHS = Object.freeze({
  name: 22.25,
  alarmId: 15,
  alarmPlan: 22.25,
  systemId: 8.5,
  alarmStatus: 8.5,
  mode: 8.5,
  orgName: 15,
})

export function getAlarmPointColumnWidth(column, visibleColumnCount, layout = '') {
  if (layout === BRAND_INSEL && INSEL_WIDTHS[column]) {
    return INSEL_WIDTHS[column]
  }

  if (layout === BRAND_BASE && BASE_WIDTHS[column]) {
    return BASE_WIDTHS[column]
  }

  return 100 / Math.max(visibleColumnCount, 1)
}

export function getAlarmPointColumnStyle(column, visibleColumnCount, options = {}) {
  const width = getAlarmPointColumnWidth(column, visibleColumnCount, options.layout)
  const padding = options.rulePage ? 'padding-left: 0!important;' : ''
  return `width:${width}%; min-width:${width}%; word-break: break-word; min-height: 38px; ${padding}`
}

export function getAlarmPointListStyle(expanded, brand = '') {
  if (!expanded) {
    return {width: '20rem'}
  }

  if (brand === BRAND_BASE || brand === BRAND_INSEL) {
    return {width: 'calc(100% - 20px)', flex: '1 1 calc(100% - 20px)'}
  }

  return {width: '70rem'}
}

export function isAlarmPointOptionEnabled(alarmPointValues, option) {
  if (!Array.isArray(alarmPointValues)) return false

  const configuredOption = alarmPointValues.find(({value}) => value === option)
  return !!configuredOption?.checked?.length
}

export function isAlarmPointTabDisabled(alarmPointValues, option, persisted = true) {
  return !persisted || !isAlarmPointOptionEnabled(alarmPointValues, option)
}
